import { observer } from 'mobx-react';
import { Page, Pagebar, PagebarTitle } from '@monorepo/base/src/components/page/page';
import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { IAdminxStore } from '../../../modules/stores';
import { ControlledTable } from '@monorepo/controlled/src/components/table-wrapper/table-wrapper';
import { useRoute } from '../../../modules/hooks/tools/use-route';
import { useStateBetweenPages } from '../../../modules/hooks/tools/use-state-between-pages';
import { useList } from '../../../modules/hooks/tools/use-list';
import { BidderModelTableModel } from '../../../modules/models/bidder-model.model';
import { useBidderModelsHeaders } from '../../../modules/hooks/theaders/bidder-models.headers';
import { usePageSettings } from '@monorepo/tools/src/lib/hooks/tools/use-page-settings';
import { sortData } from '../../../modules/hooks/tools/use-merge-with-performance';
import { useBidderModelsActions } from '../../../modules/hooks/actions/bidder-models.actions';

export const BidderModels = observer(() => {
	const {
		bidderStore: { modelsList },
	} = useStores<IAdminxStore>();

	const { currentRouteWithoutSpecialChars } = useRoute();
	const sortBy = usePageSettings().tableStore?.getSortingBy();
	const stateBetweenPages = useStateBetweenPages(() => modelsList.getList().length !== 0);

	useList<BidderModelTableModel>(modelsList, undefined, stateBetweenPages);

	const { columns } = useBidderModelsHeaders({ singleRowSelection: true });
	const { FiltersActions, SelectedActions } = useBidderModelsActions();
	const sorted = sortData(modelsList.getList().slice(), sortBy?.[0]);

	return (
		<Page>
			<Pagebar>
				<PagebarTitle>Models</PagebarTitle>
			</Pagebar>

			<ControlledTable
				currentRoute={currentRouteWithoutSpecialChars}
				columns={columns}
				data={sorted}
				defaultSortBy={sortBy}
				isLoading={modelsList.getIsLoading()}
				singleRowSelection
				getRowId={row => row.modelName}>
				{() => ({ FiltersActions, SelectedActions })}
			</ControlledTable>
		</Page>
	);
});
